<template>
  <div class="has-text-centered">
    <img
      :src="pageHeaderImage"
      :alt="pageHeaderImageAltText"
      width="100px"
      :class="pageHeaderImageClass"
    />
    <p class="is-size-1 is-size-4-mobile" >{{ pageHeading }}</p>
    <p class="is-size-4 is-size-5-mobile " >{{ pageInfo }}</p>
    <p style="color: #58595b;font-family: OpenSans-Regular" class="is-size-6-mobile">
      {{ $root.selectedLanguageData.dataEditByButton }}
    </p>
  </div>
</template>
<script>
export default {
  name: "PageHeaderPart",
  components: {},
  props: [
    "pageHeaderImage",
    "pageHeaderImageAltText",
    "pageHeading",
    "pageInfo",
    "pageInstruction",
    "pageHeaderImageClass",
  ],
  data() {
    return {};
  },
};
</script>
<style></style>
